module.exports = __webpack_public_path__ + "c63e1e5a4245666382045e5627453ca1.glb";